/* GLLF gift extras (v1)
   1) Product pages: "Make it a gift" card under the order builder (link only; the order builder is untouched)
   2) Gift box builder: ?add=<productId>&v=<variantId> puts that item in the box
   3) Cart drawer + cart page (retail only, year-round): a seasonal carrier rides to free shipping, counting retail farm goods only, with a plain note on who qualifies
   Read-only: never writes products, tags or metafields. */
(function () {
  'use strict';
  if (window.__gllfGiftExtras) return; window.__gllfGiftExtras = 1;
  var C = window.GLLF_GIFTX || {}, d = document, IC = C.icons || {};
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var img = function (k, cls) { return IC[k] ? '<img class="' + (cls || '') + '" src="' + esc(IC[k]) + '" alt="" aria-hidden="true" width="160" height="160" loading="lazy" decoding="async">' : ''; };
  function toast(msg, bad) { var t = d.createElement('div'); t.className = 'gx-toast' + (bad ? ' is-bad' : ''); t.setAttribute('data-gllf-night-skip', ''); t.setAttribute('role', 'status'); t.textContent = msg; d.body.appendChild(t); setTimeout(function () { t.remove(); }, 5200); }

  /* ---------- 1) "Make it a gift" on product pages ---------- */
  function giftCard() {
    if (!C.product) return;
    var tries = 0;
    (function place() {
      var marker = d.querySelector('[data-gllf-order-builder]');
      var ob = d.querySelector('section.gllf-order-builder');
      if (!marker || !ob) { if (++tries < 40) setTimeout(place, 250); return; }
      if (d.querySelector('.gx-gift')) return;
      var ds = marker.dataset, P = C.product;
      if (ds.retailEnabled === '0' || ds.cottageFood === '1' || ds.wholesaleApproved === '1') return;
      if (!P.available || P.giftSet || (C.excludeTypes || []).indexOf(P.type) > -1 || (P.tags || []).indexOf('cottage-food') > -1) return;
      var S = window.GLLFSeasonal, st = S && S.status(P.handle);
      if (st && st.managed && !st.open) return;
      var card = d.createElement('div');
      card.className = 'gx-gift'; card.setAttribute('data-gllf-night-skip', '');
      card.innerHTML = '<span class="gx-gift__ico">' + img('wrapped-present') + '</span>' +
        '<span class="gx-gift__t"><b>Make it a gift</b><span>Start a gift box with this item. We hand-pack it with tissue, a seal sticker and a note printed for them.</span></span>' +
        '<a class="gx-gift__go" href="' + esc(C.boxUrl || '/pages/gift-box-builder') + '">Start a gift box</a>';
      ob.insertAdjacentElement('afterend', card);
      card.querySelector('.gx-gift__go').addEventListener('click', function (e) {
        var form = (ds.formId && d.getElementById(ds.formId)) || d.querySelector('product-form form[action*="/cart/add"]') || d.querySelector('form[action*="/cart/add"]');
        var idEl = form && form.querySelector('input[name="id"]'), vid = idEl ? idEl.value : '';
        this.href = (C.boxUrl || '/pages/gift-box-builder') + '?add=' + encodeURIComponent(ds.productId || P.id) + (vid ? '&v=' + encodeURIComponent(vid) : '');
      });
      /* the season status can arrive a moment later: take the card away if this scent is out of season */
      setTimeout(function () { var s2 = S && S.status(P.handle); if (s2 && s2.managed && !s2.open) card.remove(); }, 2500);
    })();
  }

  /* ---------- 2) Gift box builder: put the chosen item in the box ---------- */
  function prefill() {
    var q; try { q = new URLSearchParams(location.search); } catch (e) { return; }
    var pid = q.get('add'), vid = q.get('v');
    if (!pid || !d.querySelector('[data-gllf-gift-box]')) return;
    try { q.delete('add'); q.delete('v'); history.replaceState(null, '', location.pathname + (q.toString() ? '?' + q : '') + location.hash); } catch (e) {}
    var tries = 0, widened = false;
    (function find() {
      var btn = d.querySelector('[data-gg-add="' + pid + '"]');
      if (!btn) {
        if (d.querySelector('[data-gg-add]')) {
          if (!widened) { var all = [].slice.call(d.querySelectorAll('[data-gg-cat]')).filter(function (c) { return /all gifts/i.test(c.textContent); })[0]; if (all) all.click(); widened = true; }
          else { var more = [].slice.call(d.querySelectorAll('button')).filter(function (b) { return /show more/i.test(b.textContent) && b.offsetParent; })[0]; if (more) more.click(); }
        }
        if (++tries < 60) return setTimeout(find, 250);
        return toast('That item can’t go in a gift box right now, usually because it’s out of season or sold out. Pick another favorite below, or use “Generate it for me.”', true);
      }
      var sel = d.querySelector('select[data-gg-var="' + pid + '"]');
      if (sel && vid && [].some.call(sel.options, function (o) { return o.value === vid; })) { sel.value = vid; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      if (btn.disabled) return toast('That size is sold out right now. Choose another size on the card, then tap Add to box.', true);
      btn.click();
      var card = btn.closest('.gg-prod'); if (card) { card.scrollIntoView({ behavior: 'smooth', block: 'center' }); card.classList.add('gx-picked'); }
      toast('Added to your gift box. Pick a moment, add a few more goodies, and we’ll wrap it.');
    })();
  }

  /* ---------- 3) Free-shipping meter in the cart: the carrier follows the calendar (all dates from gllf-occasions-v1.js) ----------
     Christmas season: Santa's sled · Valentine's: a love letter · Easter: the bunny · Mother's Day: a bouquet ·
     Father's Day: a canoe · Grandparents Day: a tractor · in between, the farm's season icon (sled, butterfly,
     sailboat, tractor, jack-o'-lantern for Halloween week, turkey for Thanksgiving week).
     While an occasion is open, a line under the meter shows the next order-by date. */
  var OC = window.GLLFOccasions;
  var FLIP = { sled: 1, rabbit: 1, turkey: 1 }; /* painted facing left; turned so they travel toward the goal */
  function now() { return OC ? OC.now() : Date.now(); }
  function over() { return (window.GLLF_HOLIDAY && window.GLLF_HOLIDAY.dates) || null; }
  function carrier() { return OC ? OC.carrierIcon(now(), over()) : 'sled'; }
  function cutLine() {
    if (!OC) return '';
    var n = now(), D = OC.current(n, over());
    if (!D) return '';
    var name = D.def.name;
    if (n >= D.faithStart) return '';
    var lanes = [['ground shipping', D.ground], ['2-day shipping', D.priority], ['express shipping', D.express, ', 12 pm ET']];
    for (var i = 0; i < lanes.length; i++) if (n < lanes[i][1]) {
      var label = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'short', month: 'short', day: 'numeric' }).format(new Date(lanes[i][1]));
      return name + ' delivery: ' + lanes[i][0] + ', order by ' + label + (lanes[i][2] || '');
    }
    return 'Shipping is done for ' + name + '. A digital gift card still arrives in minutes.';
  }
  /* Free shipping counts retail farm goods only (cottage food included). Plant pre-orders ship separately with their
     own shipping & handling, items that don't ship (gift cards, services) don't count, and wholesale never qualifies
     (wholesale accounts don't see this meter at all). The rule at checkout lives in the Great Lakes Deposits app. */
  var MIN = Number(C.freeShipMin || 199) * 100;
  var NO_COUNT = (C.freeShipExcludeTypes || ['Live Plants']).map(function (t) { return t.toLowerCase(); });
  var cartCache = null, cartAt = 0, cartReq = null;
  function getCart(force) {
    if (!force && cartCache && Date.now() - cartAt < 800) return Promise.resolve(cartCache);
    if (cartReq) return cartReq;
    cartReq = fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { cartReq = null; if (c) { cartCache = c; cartAt = Date.now(); } return c; })
      .catch(function () { cartReq = null; return null; });
    return cartReq;
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function tally(c) {
    var q = 0, plants = 0, items = 0;
    (c && c.items || []).forEach(function (it) {
      items += it.quantity;
      var type = String(it.product_type || '').toLowerCase();
      if (NO_COUNT.indexOf(type) > -1) { plants += it.quantity; return; }
      if (it.requires_shipping === false) return;
      q += it.final_line_price;
    });
    return { q: q, plants: plants, items: items };
  }
  function sleigh(force) {
    if (!C.cartSleigh) return;
    if (C.freeShipOn === false) { [].forEach.call(d.querySelectorAll('.wbship'), function (box) { box.classList.add('gx-ship-off'); var el = box.querySelector('.gx-sleigh'); if (el) el.remove(); }); return; }
    getCart(force).then(function (c) {
      var T = tally(c);
      [].forEach.call(d.querySelectorAll('.wbship'), function (box) {
        var el = box.querySelector('.gx-sleigh');
        /* only plant pre-orders in the cart: free shipping doesn't apply, so hide the whole widget */
        var plantOnly = T.items > 0 && T.q === 0 && T.plants > 0;
        box.classList.toggle('gx-ship-off', plantOnly);
        if (plantOnly) { if (el) el.remove(); return; }
        var full = T.q >= MIN, pct = full ? 100 : Math.max(4, Math.min(96, T.q / MIN * 100));
        box.classList.add('gx-has-sleigh');
        if (!el) { el = d.createElement('div'); el.className = 'gx-sleigh'; el.setAttribute('data-gllf-night-skip', ''); box.appendChild(el); }
        var car = carrier(), cut = cutLine();
        var key = T.q + '|' + T.plants + '|' + car + '|' + cut;
        if (el.dataset.key === key) return;
        el.dataset.key = key;
        el.classList.toggle('is-full', full);
        var head = full ? '<b>You&rsquo;ve unlocked free shipping</b> on your farm goods.'
          : 'Spend <b>' + money(MIN - T.q) + '</b> more on farm goods for <b>free shipping</b>.';
        var fine = 'Retail orders only, US addresses. Wholesale orders don&rsquo;t qualify. ' +
          (T.plants ? 'Your plant pre-order ships separately with its own shipping &amp; handling.' : 'Plant pre-orders ship separately and don&rsquo;t count.');
        el.innerHTML = '<p class="gx-ship__head">' + head + '</p>' +
          '<div class="gx-sleigh__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '" aria-label="Progress to free shipping">' +
          '<span class="gx-sleigh__fill" style="width:' + pct.toFixed(1) + '%"></span>' +
          '<span class="gx-sleigh__sled' + (FLIP[car] ? ' is-flip' : '') + '" data-carrier="' + esc(car) + '" style="left:' + pct.toFixed(1) + '%">' + img(IC[car] ? car : 'sled') + '</span>' +
          '<span class="gx-sleigh__goal">' + img('wrapped-present') + '</span></div>' +
          '<p class="gx-ship__fine">' + fine + '</p>' +
          (cut ? '<p class="gx-sleigh__cut">' + esc(cut) + '</p>' : '');
      });
    });
  }
  function sig() { return [].map.call(d.querySelectorAll('.wbship'), function (w) { var b = w.querySelector('#freeShippingBar, .determinate'), t = w.querySelector('.wbship_wrapper'); return (t ? t.textContent.replace(/\s+/g, ' ') : '') + (b ? b.style.width : ''); }).join('|'); }
  function watchCart() {
    if (!C.cartSleigh) return;
    var last = sig(); sleigh();
    d.addEventListener('cart:updated', function () { sleigh(true); });
    var t, check = function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var now = sig(), missing = [].some.call(d.querySelectorAll('.wbship'), function (w) { return !w.querySelector('.gx-sleigh') && !w.classList.contains('gx-ship-off'); });
        if (now !== last || missing) { last = now; sleigh(true); }
      }, 150);
    };
    var watched = [];
    function hook() {
      [].forEach.call(d.querySelectorAll('cart-drawer, cart-items, #main-cart-footer, .cart__footer'), function (el) {
        if (watched.indexOf(el) > -1) return; watched.push(el);
        new MutationObserver(function (muts) {
          for (var i = 0; i < muts.length; i++) { var n = muts[i].target; if (!(n.closest && n.closest('.gx-sleigh'))) { check(); break; } }
        }).observe(el, { childList: true, subtree: true, characterData: true });
      });
    }
    hook(); setTimeout(hook, 2000);
  }

  function boot() { giftCard(); prefill(); watchCart(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
